import { useEffect, useState } from "react";
import {UI_Table} from './ui-table';
import axios from "axios";
const static_status_list = ['Open', 'Prospecting', 'Closed', 'Opening Soon']
const range_distances_guards = {'Meters': [100, 25000], 'Miles': [.1, 25], 'Minutes': [1, 50], 'Circle Radius Miles': [.1, 50], 'Circle Radius Meters': [100, 25000]}
const range_option_const = {Meters: ['1000', '10000', '25000'], Miles: ['1', '5', '10'], Minutes: ['5', '10', '15'], Custom: ['0'], 'Circle Radius Miles': ['1', '5', '10'], 'Circle Radius Meters': ['1000', '10000', '25000']}

const age_segments = {
    'under_18': 'Under 18',
    '18_24': '18 - 24',
    '25_34': '25 - 34',
    '35_44': '35 - 44',
    '45_54': '45 - 54',
    '55_64': '55 - 64',
    '65_plus': '65+'
  }
  
  const income_segments = {
    'low_income': '$0 - 30,000',
    'lower_middle_income': '$30,000 - 50,000',
    'middle_income': '$50,000 - 75,000',
    'upper_middle_income': '$75,000 - 125,000',
    'high_income': '$125,000 - 200,000',
    'very_high_income': '$200,000+'
  }
  
  
  const region_mapping = {
    'Urban Core': 'Metro',
    Urban: 'City',
    Suburban: 'Suburbs',
    Rural: 'Rural'
  }

export const ExportDetails = ({freetier, defaultTags, statusList = static_status_list, defaultRange, closeFindingLocation, idvalue, Competitor_type, sidebarUpdateLocationArea, getlocationrange}) => {
    // category => multiselect
    // edit location distance
    const range = idvalue?.circle?.range ? idvalue.circle.range : defaultRange;
    
    const [idvalFinal, setIdvalFinal] = useState(idvalue);
    const [rangeOptions, setRangeOptions] = useState(range_option_const[range?.type]);
    const [rangeTypes, setRangeTypes] = useState(range?.type);
    const [rangeDistance, setRangeDistance] = useState(range?.distance ? range.distance.toString(): '0');
    const [category, setCategory] = useState([]);
    const [location_total_agg, setLocation_total_agg] = useState([])
    const [name, setName] = useState(idvalue?.name);
    const [brand, setBrand] = useState(idvalue?.brand ? idvalue.brand : '');
    const [address, setAddress] = useState(idvalue?.address);
    const [status, setStatus] = useState(statusList);
    const [tags, setTags] = useState(defaultTags);
    const [selectedStatus, setSelectedStatus] = useState(idvalue?.status);
    const [selectedTags, setSelectedTags] = useState(idvalue?.tags);
    const [segmentDetails, setSegmentDetails] = useState({});
    const [familyDetails, setFamilyDetails] = useState(null);
    const [totalPopulation, setTotalPopulation] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    }));
    
    const calculateSegmentValues = (segmentation, segmentValues) => {
        if(!segmentValues) return {highestAgeGroup: null, highestAgeCount: null, highestIncomeGroup: null, highestIncomeCount: null, totalCount: null}
        
        // Initialize counters
        const ageGroupCounts = {};
        const incomeGroupCounts = {};
        let totalCount = 0;
        console.log('segmentValues: ', segmentValues)
        
        // Process each data item
        segmentValues.forEach(item => {
          const ageGroup = item.age_group;
          const incomeGroup = item.income_group;
          const count = item.total_pop || 0;
          
          // Skip under_18 age group
          if (ageGroup === 'under_18') {
            return;
          }

          if (ageGroup === '65_plus') {
            return;
          }
          
          // Add to total count
          totalCount += count;
          
          // Count by age group
          if (!ageGroupCounts[ageGroup]) {
            ageGroupCounts[ageGroup] = 0;
          }
          ageGroupCounts[ageGroup] += count;
          
          // Count by income group (exclude "None")
          if (incomeGroup !== "None") {
            if (!incomeGroupCounts[incomeGroup]) {
              incomeGroupCounts[incomeGroup] = 0;
            }
            incomeGroupCounts[incomeGroup] += count;
          }
        });
        
        // Find age group with highest count
        let highestAgeGroup = null;
        let highestAgeCount = 0;
        for (const [ageGroup, count] of Object.entries(ageGroupCounts)) {
          if (count > highestAgeCount) {
            highestAgeGroup = ageGroup;
            highestAgeCount = count;
          }
        }
        
        // Find income group with highest count
        let highestIncomeGroup = null;
        let highestIncomeCount = 0;
        for (const [incomeGroup, count] of Object.entries(incomeGroupCounts)) {
          if (count > highestIncomeCount) {
            highestIncomeGroup = incomeGroup;
            highestIncomeCount = count;
          }
        }
        
        highestAgeGroup = age_segments[highestAgeGroup]
        highestIncomeGroup = income_segments[highestIncomeGroup]
        
        // Return results
        return {
          highestAgeGroup,
          highestAgeCount,
          highestIncomeGroup,
          highestIncomeCount,
          totalCount: segmentation.visitors
        };
      };

    useEffect(() => {
        console.log('idvalue: ', idvalue)
        if(idvalue) {
            // getIdMain()
            setIdvalFinal(idvalue)
            setRangeOptions(range_option_const[range?.type])
            setRangeTypes(range?.type)
            setRangeDistance(range?.distance ? range.distance.toString(): '0')
            setName(idvalue.name)
            setBrand(idvalue.brand ? idvalue.brand : '')
            setAddress(idvalue.address)
            setStatus(statusList)
            setTags(defaultTags)
            setSelectedStatus(idvalue.status)
            setSelectedTags(idvalue.tags)
            const segment_details = calculateSegmentValues(idvalue?.data_circle?.segmentation, idvalue?.data_circle?.segmentation?.segmentMap)
            const family_details =  idvalue?.data_circle?.family?.current
            const total_population = idvalue?.data_circle?.total_age_sex?.pop_2018_f
            
            setSegmentDetails(segment_details)
            setFamilyDetails(family_details)
            setTotalPopulation(total_population)
            if(!freetier) getSpreadSheetDownload(idvalue.data_circle, idvalue)
        }
    }, [idvalue]);

    const family_income = (age_values) => {
        if(!age_values) return;
        const header = ['Period', '$0 - 25', '$25 - 45', '$45 - 60', '$60 - 75', '$75 - 100', '$100 - 125', '$125 - 150', '$150 - 200', '$200+']
        const current = ['Current',  ...Object.values(age_values['2018'])]
        const previous = ['2012', ...Object.values(age_values['2012'])]
        return {sheet: 'Family Income Distribution',header, column_types: ['@', '0', '0', '0', '0', '0', '0', '0', '0', '0'], rows: [current, previous]}
    }

    const age_income_func = (age_values) => {
        if(!age_values) return;
        const header = ['Period', 'Under 25', '25 - 44', '44 - 64', '64 and Up']
        const current_data = age_values[2018]
        const previous_data = age_values[2012]
        const current = ['Current',  current_data['Under 25'], current_data['25 - 44'], current_data['44 - 64'], current_data['64 over']]
        const previous = ['2012', previous_data['Under 25'], previous_data['25 - 44'], previous_data['44 - 64'], previous_data['64 over']]
        return {sheet: 'Age Income Distribution',header, column_types: ['@', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0'], rows: [current, previous]}
    }

    const age_spend_func = (age_spend_values) => {
        const spendCategories = ["Housing", "Food", "Entertainment", "Apparel", "Transportation", "Healthcare"];
        const age = {"25": "Under 25", "44": "25 - 44", "64": "44 - 64", "84": "64 and Up"}
        const aggregated = {};
        const counts = {};
    
        // Initialize the object with races and age groups
        spendCategories.forEach(spend => {
            aggregated[spend] = { "Under 25": 0, "25 - 44": 0, "44 - 64": 0, "64 and Up": 0 }
            counts[spend] = { "Under 25": 0, "25 - 44": 0, "44 - 64": 0, "64 and Up": 0 }
        });
    
        // Aggregate the data
        age_spend_values.forEach(entry => {
            let groupName = age[entry.age];    
            // Sum the values for each race in the correct age group
            Object.entries(entry.spent).forEach(([key, value]) => {
                if (entry.spent[key]) {
                    aggregated[key][groupName] += value;
                    counts[key][groupName] += 1;
                }
            });
        });
        function safeDivide(numerator, denominator) {
            return denominator ? Math.round(numerator / denominator) : 0;
        }
        const averages = {};
        spendCategories.forEach(category => {
            averages[category] = {
                "Under 25":  safeDivide(aggregated[category]["Under 25"], counts[category]["Under 25"]),
                "25 - 44":   safeDivide(aggregated[category]["25 - 44"], counts[category]["25 - 44"]),
                "44 - 64":   safeDivide(aggregated[category]["44 - 64"], counts[category]["44 - 64"]),
                "64 and Up": safeDivide(aggregated[category]["64 and Up"], counts[category]["64 and Up"])
            };
        });
        const rows = spendCategories.map(spend => [spend, ...Object.values(averages[spend])]);
        return {sheet: 'Age Spend Distribution', 'header': ['Race', 'Under 25', '25 - 44', '44 - 64', '64 and Up'], column_types: ['@', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0', '"$"#,##0;[Red]"-$"#,##0'], 'rows': rows}
    }


    const age_income_region_func = (age_income_region_values) => {
        age_income_region_values = age_income_region_values ? age_income_region_values : [];
        
        const rows = age_income_region_values.map((each) => {
            const values = {};
            values['Age Group'] = age_segments[each['age_group']]
            values['Region Type'] = region_mapping[each['region_type']]
            values['Income Group'] = income_segments[each['income_group']]
            values['Visitors'] = each['total_pop']
            return [values['Age Group'], values['Region Type'], values['Income Group'], values['Visitors']]
        })

        return {sheet: 'Foot Traffic by Age, Income, Region ', 'header': ['Age Group', 'Region Type', 'Income Group', 'Visitors'], column_types: ['@', '@', '@', '0'], 'rows': rows}
    }

    const commercial_shops_func = (shops_near) => {
        if(!shops_near) return;
        const rows = shops_near.map((e) => [e.Name_final, e.average_rent_sqft, e.loc_overlap_count])
        return {sheet: 'Shopping Centers In Range', 'header': ['Name', 'Est. Rent SQFT', 'Est. Locations Count'], column_types: ['@', '"$"#,##0.00;[Red]"-$"#,##0.00', '0'], 'rows': rows}
    }

    const commercial_locations_func = (location_near) => {
        if(!location_near) return;
        const rows = location_near.map((e) => [e.Name_final, e.count, e.loc_count])
        return {sheet: 'Shops In Range', 'header': ['Name', 'Count', 'Overall Est. Count'], column_types: ['@', '0', '0'], 'rows': rows}
    }

    const getSpreadSheetDownload = async (idvalue, idvalue_raw) => {
        const location_information = {sheet: 'Location Information', header: [`Name: ${idvalue_raw.name}`], rows: [[`Address: ${idvalue_raw.address}`], [`Current Status: ${idvalue_raw.status}`], [`Range: ${idvalue_raw.circle?.range?.distance} ${idvalue_raw.circle?.range?.type}`], [`Revenue: ${idvalue_raw.revenue}`], [`Expense: ${idvalue_raw.expense}`], [`Lease: ${idvalue_raw.lease}`]]}
        let token = localStorage.getItem("auth-token");
        var export_excel = null;
        if(idvalue.municipality_data) return;

        const age_income = age_income_func(idvalue?.age_income_overall);
        const age_income_region_dist = age_income_region_func(idvalue?.segmentation?.segmentMap);
        const family = family_income(idvalue?.family_values);
        const commercial_shops = commercial_shops_func(idvalue?.commercial_data?.shops_near);
        const commercial_locations = commercial_locations_func(idvalue?.commercial_data?.location_total_agg);
        export_excel = await axios.post('/gettheurl/export', {location_information, age_income, age_income_region_dist, family, commercial_shops, commercial_locations}, {
            responseType: 'blob', headers:{ "auth-token": token}
        })            

        
        const url = window.URL.createObjectURL(new Blob([export_excel.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download =  `mapchise_${idvalue_raw.name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        // const degree = idvalue.degree;
        // const occupation = idvalue.occupation;

    }

    const numberWithCommas = (x, dollar=true) => {
        if(!x) return 'No Data'
        if(x === 0) return 'No Data'
        if(!dollar) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    return (
    <div className="sidebar-realestate-total">
        <div className="mt-20 mb-20">
            <div >
                <div className="" ><h2 className="font-weight600 display-inline-block mb-15 center-content width-100">Export Report{brand ? ` for ${brand}`: ''}</h2></div>
                <div className="">
                    {name && <div className="mt-5 mb-15" >Location Name: <div className="font-weight600 display-inline-block">{name}</div></div>}

                    {brand && <div className="mt-5 mb-15" >Brand Name: <div className="font-weight600 display-inline-block">{brand}</div></div>}
                    <div className="mt-5 mb-15">Address: <div className="font-weight600 display-inline-block">{address}</div></div>
                    <div className="mt-5 mb-15">Status: <div className="font-weight600 display-inline-block">{selectedStatus}</div></div>
                    {selectedTags?.length > 0 && <div className="mt-5 mb-15">Tags: <div className="font-weight600 display-inline-block">{selectedTags?.join(', ')}</div> </div>}
                    <div className="mt-5 mb-15">Calculated Range: <div className="font-weight600 display-inline-block">{rangeDistance} {rangeTypes}</div></div>
                    <div className="mt-5 mb-15">Report Date: <div className="font-weight600 display-inline-block">{currentDate}</div></div>
                    {/* <div className="mt-5 mb-15">Description: <div className="font-weight600 display-inline-block mt-5">This report analyzes your current customer base and provides demographic information for the population within the specified calculated range. We then use AI to match your current customers' profiles with similar markets nationwide, identifying areas with low competition ideal for your expansion.</div></div> */}
                    {idvalue?.revenue && <div className="mt-5 mb-15">Revenue: <div className="font-weight600 display-inline-block">{numberWithCommas(idvalue.revenue)}</div></div>}
                    {idvalue?.expense && <div className="mt-5 mb-15">Expense: <div className="font-weight600 display-inline-block">{numberWithCommas(idvalue.expense)}</div></div>}
                    {idvalue?.lease && <div className="mt-5 mb-15">Lease: <div className="font-weight600 display-inline-block">{numberWithCommas(idvalue.lease)}</div></div>}
                    <div className="mt-5 mb-15">
                        <div className=" mb-10">Location Summary:</div>
                        <div className="pl-10">
                            <p className="color-black">
                                {segmentDetails?.totalCount && (
                                    <>This location sees approximately <span className="font-weight600">{numberWithCommas(segmentDetails.totalCount, false)}</span> <span className="font-weight600">visitors</span> per month, based on our recent foot traffic data. </>
                                )}
                                {segmentDetails?.highestAgeGroup && (
                                    <>The most represented <span className="font-weight600">age group</span> visiting this location is <span className="font-weight600">{segmentDetails.highestAgeGroup}</span>, making up the largest share of the customer base. </>
                                )}
                                {segmentDetails?.highestIncomeGroup && (
                                <>The most likely <span className="font-weight600">income group</span> visiting this store falls within the <span className="font-weight600">{segmentDetails.highestIncomeGroup}</span> bracket, highlighting the typical economic profile of the store’s visitors. </>
                                )}
                                {familyDetails && (
                                    <>There are approximately <span className="font-weight600">{numberWithCommas(familyDetails, false)}</span> <span className="font-weight600">family households</span> within the analyzed range. </>
                                )}
                                {totalPopulation && (
                                <>The <span className="font-weight600">total target population</span> within the analyzed range is approximately <span className="font-weight600">{numberWithCommas(totalPopulation, false)}</span> people. </>
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}